
import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import qs from 'qs';

import globalWin from '@/utils/globalWin';
// import { getScrollBottom, scrollLimit } from '@/utils/scroll';

@Component({
  name: 'MsgSatisfactionSurvey',
})
class MsgSatisfactionSurvey extends Vue {
  @Inject()
  wpaDetail: any;

  @Prop() data: any;

  originConfig: any = {};
  config: any = {};

  get reqSuffix() {
    if (!this.data) return '';
    return this.data.content.content;
  }

  mounted() {
    this.fetchData();
  }

  fetchData() {
    const url = `/v1/qf/report/survey/getSatisfaction?${this.reqSuffix}`;
    this.$ajax
      .get(url)
      .then((res) => {
        if ([0, 1].includes(res?.data?.code)) {
          this.config = res.data.data || {};
          this.handle(res?.data || {});
        }
      });
  }

  handle(info) {
    this.originConfig = info;
    const {
      code,
      data,
      evaluation_label,
      reply,
      satisfaction_tag: tags = [],
      solve_the_problem,
      title,
      extendData,
    } = info;
    // 0: 未提交  1: 已提交
    if ([0, 1].includes(code)) {
      const result: any = {
        editable: 0 === code,
      };
      data.forEach((item) => {
        if (Number(item.id) === 1) {
          result.title = item.title;
          if (code === 1) result.value = Number((item.contents && item.contents[0]).score || 1);
        }
        if (Number(item.id) === 2) {
          const content = (item.contents && item.contents[0]) || {
            content: '',
            maxNum: 60,
          };
          result.availLetterSum = content.maxNum;
          result.showOpinion = true;
          if (code === 1) result.text = content.content;
        }
        if (Number(item.id) === 3) {
          if (code === 1) {
            const ids = (item.contents && item.contents[0] && item.contents[0].content) || [];
            result.ids = ids.map(tag => tag.id);
          } else {
            result.ids = [];
          }
        }
        if (Number(item.id) === 4) {
          if (code === 1) result.isSolve = Number((item.contents && item.contents[0] && item.contents[0].content) || 0);
        }
      });
      const temp: any = [];
      (tags || []).forEach((item, index) => {
        item.forEach((sub) => {
          temp.push(Object.assign({ level: 5 - index }, sub));
        });
      });
      if (!result.value) result.value = 5;
      const params: any = {
        ...result,
        // eslint-disable-next-line camelcase
        showTags: evaluation_label === 1,
        // eslint-disable-next-line camelcase
        showSolve: solve_the_problem === 1,
        reply,
        showTitle: !!title,
        title,
        tags: temp,
        extendData,
      };
      this.config = { ...params };
      // @ts-ignore @tencent/feedback包不能通过import引入打入仓库内，会和TcPlayer的babel冲突，所以这里只能采用cdn来引入这个包
      new window.Feedback(this.$refs.surveyRef, params, {
        // 提交回调
        onSubmit: result => this.submit(result),
      });
      this.$nextTick(() => this.onLoad());
    }
  }

  submit(result) {
    const temp: any = [];
    const { value, text, ids, isSolve } = result;
    temp[0] = { id: 1, contents: [value] };
    temp[1] = { id: 2, contents: [text] };
    if (this.config.showTags) {
      temp[2] = {
        id: 3,
        contents: this.config.tags.filter(item => ids.includes(item.id)),
      };
    }
    if (this.config.showSolve) {
      temp[3] = {
        id: 4,
        contents: isSolve,
      };
    }
    Object.assign(this.config, { editable: false });
    const { kfuin } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    this.$ajax
      .post(
        `/v1/qf/report/survey/sendSatisfaction?kfuin=${kfuin}`,
        qs.stringify({
          kfuin,
          uk: this.originConfig.uk,
          submit: temp,
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      )
      .then((res) => {
        const { code, message } = res?.data || {};
        const tip = 0 === code
          ? this.$t('chat_feedback_success_msg')
          : (message || this.$t('chat_feedback_error_msg'));
        this.$Toast(tip);
      })
      .catch(err => this.$Toast({ text: err.message || '提交满意度错误！', type: 'error' }));
  }

  onLoad() {
    // if (getScrollBottom() < scrollLimit) {
    // eslint-disable-next-line dot-notation
    globalWin['scrollToBottom'](true, 500);
    // }
  }
}

export default MsgSatisfactionSurvey;
